/**
 * @file: onErrorIgnore.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export function onErrorIgnore(error: any): void {
  console.error(error);
}
